<script>
  import {getContext, onDestroy, onMount} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import VerizonMediaLogo from '../svgs/VerizonMediaLogo.svelte'

  export let title = null
  export let titles = null
  export let mobile
  export let desktop
  export let alt
  export let showLogo = true

  const controller = getContext('framedImageController')

  let bg, self, tl, st, frameWidth = 100, frameHeight = 100, maskId = ''

  $: isDimmed = (title && title.length > 0) || (titles && titles.length > 0)

  onMount(() => {
    maskId = 'mask' + Math.round(Math.random() * 10000)
    createTimeline()

    if(controller && controller.timeline) {
      controller.timeline = tl
      controller.rebuild = () => {
        controller.timeline = null
        tl?.pause().kill()
        createTimeline()
        controller.timeline = tl
      }
    } else {
      st = ScrollTrigger.create({
        trigger: self,
        start: 'top 70%',
        toggleActions: 'play play play pause',
        animation: tl
      })
    }
  })

  function createTimeline () {
    tl = gsap.timeline()
    tl.fromTo(self.querySelector('.image'), {clipPath: `inset(40px 40px)`}, {clipPath: `inset(0px 0px)`, ease: 'power2.out', duration: 1}, 0)
    tl.fromTo(self.querySelector('img'), {scale: 1.5, opacity: 0}, {scale: 1, opacity: isDimmed ? 0.6 : 1, ease: 'power2.out', duration: 1}, 0)
    if(title) {
      tl.fromTo(self.querySelector('.title'), {opacity: 0}, {opacity: 1, ease: 'none', duration: 0.75}, .5)
    }
    const logo = self.querySelector('.logo')
    if(logo) tl.fromTo(logo, {opacity: 0}, {opacity: 1, force3D: true, ease: 'none', duration: 0.75}, .65)
    tl.fromTo(self.querySelector('.foot'), {y: 20, opacity: 0}, {y: 0, opacity: 1, ease: 'power2.out', duration: 0.75}, .75)
    tl.fromTo(self.querySelector('.circle-mask'), {x: frameWidth * 2.5, y: frameHeight * 2.5}, {x: 0, y: 0, ease: 'power1.out', duration: 1.5}, .15)
    tl.fromTo(self.querySelector('.frame-fill'), {opacity: 0}, {opacity: 1, ease: 'none', duration: 1}, .15)
  }

  onDestroy(() => {
    tl?.kill()
    st?.kill()
    if(controller) controller.timeline = null
  })
  
</script>
<div class="tv" bind:this={self}>
  <div class="frame" bind:clientWidth={frameWidth} bind:clientHeight={frameHeight}>
    {#if titles && titles.length}
      <div class="titles-wrap">
        {#each titles as txt (txt)}
          <div class="item">
            <h2 class="title">{txt}</h2>
          </div>
        {/each}
      </div>
    {:else if title}
      <h2 class="title single">{title}</h2>
    {/if}
    <div class="image">
      <picture>
        <source srcset={mobile} media="(max-width: 767px)" />
        <source srcset={desktop} media="(min-width: 768px)" />
        <img bind:this={bg} src={mobile} alt={alt} class:dimmed={isDimmed} />
      </picture>
    </div>
    {#if showLogo}
      <div class="logo"><VerizonMediaLogo /></div>
    {/if}
    <svg class="frame-border" viewBox="0 0 {frameWidth} {frameHeight}">
      <defs>
        <clipPath id="circle-{maskId}">
          <circle class="circle-mask" cx={frameWidth / 2} cy={frameHeight / 2} r={frameWidth * 2} fill="white" />
        </clipPath>
      </defs>
      <rect class="frame-fill" width={frameWidth} height={frameHeight} rx="4" fill="white" clip-path="url(#circle-{maskId})" />
      <rect class="knockout" x="1" y="1" width={frameWidth - 2} height={frameHeight - 2} rx="3.75" fill="black" />
       <!-- <svg width="100%" height="100%" viewBox="0 0 345 195" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="frame-outline" d="M1 3C1 1.89543 1.89543 1 3 1H342C343.105 1 344 1.89543 344 3V97.5V192C344 193.105 343.105 194 342 194H2.99999C1.89542 194 1 193.105 1 192V3Z" stroke="white"/>
      </svg> -->
      <!-- <rect class="frame-outline" width={frameWidth} height={frameHeight} rx="4" fill="white" stroke-width="2" fill="none" /> -->
    </svg>
  </div>
  <div class="foot">
    <svg viewBox="0 0 155 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="155" height="5" rx="1" fill="white"/>
    </svg>
  </div>
</div>

<style>
  .frame {
    position: relative;
    height: 0;
    padding-bottom: 55.4%;
  }
  .frame-border {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .title {
    max-width: 66%;
    padding-left: 6%;
  }
  .title.single,
  .titles-wrap {
    position: absolute;
    right: 0;
    top: 10%;
    left: 0;
    z-index: 2;    
  }
  .titles-wrap .item {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .titles-wrap .title {
    max-width: 75%;
  }
  .image {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 1.2%;
    z-index: 1;
  }
  picture {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
  }
  img {
    border-radius: 1px;
    object-fit: cover;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  img.dimmed {
    opacity: 0.6;
  }
  .logo {
    position: absolute;
    bottom: 10%;
    left: 6%;
    width: 13.84%;
    height: 10.81%;
    z-index: 2;
  }
  .foot {
    padding-top: 1.4%;
  }
  .foot svg {
    width: 45%;
    margin: auto;
  }
  @media(min-width: 768px) {
    .title {
      font-size: 2.75rem;
      line-height: 0.95;
      width: 66%;
    }
  }
</style>